module.exports = __webpack_public_path__ + "static/img/border_paws_800x747.5ab58c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/border_paws_800x747.jpg
// module id = YsNz
// module chunks = 0